// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\DataCache\ApiDataCacheUpdate.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { BerthCapability, BerthCapabilityData, BerthCapabilityOptions } from 'data/models/BerthCapability';
import { BerthCapabilityAssignment, BerthCapabilityAssignmentData, BerthCapabilityAssignmentOptions } from 'data/models/BerthCapabilityAssignment';
import { BerthClosure, BerthClosureData, BerthClosureOptions } from 'data/models/BerthClosure';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';
import { BerthReservationVersion, BerthReservationVersionData, BerthReservationVersionOptions } from 'data/models/BerthReservationVersion';
import { CargoActivity, CargoActivityData, CargoActivityOptions } from 'data/models/CargoActivity';
import { Comment, CommentData, CommentOptions } from 'data/models/Comment';
import { CoordinationCard, CoordinationCardData, CoordinationCardOptions } from 'data/models/CoordinationCard';
import { CoordinationCardRelevance, CoordinationCardRelevanceData, CoordinationCardRelevanceOptions } from 'data/models/CoordinationCardRelevance';
import { CoordinationCardSelf, CoordinationCardSelfData, CoordinationCardSelfOptions } from 'data/models/CoordinationCardSelf';
import { CoordinationCardVersion, CoordinationCardVersionData, CoordinationCardVersionOptions } from 'data/models/CoordinationCardVersion';
import { Country, CountryData, CountryOptions } from 'data/models/Country';
import { CruiseActivity, CruiseActivityData, CruiseActivityOptions } from 'data/models/CruiseActivity';
import { DataCacheUpdateEntities as _DataCacheUpdateEntities, DataCacheUpdateEntitiesData as _DataCacheUpdateEntitiesData, DataCacheUpdateEntitiesOptions as _DataCacheUpdateEntitiesOptions } from 'data/models/DataCacheUpdate';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { Issue, IssueData, IssueOptions } from 'data/models/Issue';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { ItineraryPointVersion, ItineraryPointVersionData, ItineraryPointVersionOptions } from 'data/models/ItineraryPointVersion';
import { Location, LocationData, LocationOptions } from 'data/models/Location';
import { LogEvent, LogEventData, LogEventOptions } from 'data/models/LogEvent';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { OverrideServiceVessel, OverrideServiceVesselData, OverrideServiceVesselOptions } from 'data/models/OverrideServiceVessel';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { PierGroup, PierGroupData, PierGroupOptions } from 'data/models/PierGroup';
import { PilotsDataCacheUpdateEntities, PilotsDataCacheUpdateEntitiesData, PilotsDataCacheUpdateEntitiesOptions } from 'data/models/PilotsDataCacheUpdateEntities';
import { Port, PortData, PortOptions } from 'data/models/Port';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { PortCallChange, PortCallChangeData, PortCallChangeOptions } from 'data/models/PortCallChange';
import { PortCallVersion, PortCallVersionData, PortCallVersionOptions } from 'data/models/PortCallVersion';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';
import { ScheduleDateEntity, ScheduleDateEntityData, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';
import { ScheduleDateEvent, ScheduleDateEventData, ScheduleDateEventOptions } from 'data/models/ScheduleDateEvent';
import { Share, ShareData, ShareOptions } from 'data/models/Share';
import { TaggedCommentUser, TaggedCommentUserData, TaggedCommentUserOptions } from 'data/models/TaggedCommentUser';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';
import { TopicCardAvailableAttachment, TopicCardAvailableAttachmentData, TopicCardAvailableAttachmentOptions } from 'data/models/TopicCardAvailableAttachment';
import { TopicCardChange, TopicCardChangeData, TopicCardChangeOptions } from 'data/models/TopicCardChange';
import { TopicCardOption, TopicCardOptionData, TopicCardOptionOptions } from 'data/models/TopicCardOption';
import { TopicCardSelectedOption, TopicCardSelectedOptionData, TopicCardSelectedOptionOptions } from 'data/models/TopicCardSelectedOption';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';
import { VesselChange, VesselChangeData, VesselChangeOptions } from 'data/models/VesselChange';
import { WartsilaDataCacheUpdateEntities, WartsilaDataCacheUpdateEntitiesData, WartsilaDataCacheUpdateEntitiesOptions } from 'data/models/WartsilaDataCacheUpdateEntities';

// DataCacheUpdateData is the class that DataCacheUpdate serializes to/from
export interface DataCacheUpdateData {
	
	
    Deletes : _DataCacheUpdateEntitiesData;
    Timestamp : /* ISO8601 */ string;
    Updates : _DataCacheUpdateEntitiesData;
}

// DataCacheUpdateOptions is the class which may be passed to the DataCacheUpdate constructor to define optional initial data values
export interface DataCacheUpdateOptions {
	
	
    Deletes? : _DataCacheUpdateEntitiesOptions;
    Timestamp? : /* ISO8601 */ string;
    Updates? : _DataCacheUpdateEntitiesOptions;
}

export class DataCacheUpdate {
	
	
    public Deletes : _DataCacheUpdateEntities;
    public Timestamp : DataSignal<TZDate>;
    public Updates : _DataCacheUpdateEntities;

    constructor();
    constructor(data : DataCacheUpdateOptions);
    constructor(data: DataCacheUpdateOptions | null = null) {
	    
	    
        this.Deletes = data && data.Deletes !== undefined ? new _DataCacheUpdateEntities(data.Deletes) : new _DataCacheUpdateEntities();
        this.Timestamp = jsonableObservable(S.value<TZDate>(data && data.Timestamp !== undefined ? new TZDate(data.Timestamp) : new TZDate(0), TZDate.eq));
        this.Updates = data && data.Updates !== undefined ? new _DataCacheUpdateEntities(data.Updates) : new _DataCacheUpdateEntities();
    }

    static key(obj : DataCacheUpdate) {
        return ;
    }
    
    static dataKey(obj : DataCacheUpdateOptions) {
        return ;
    }

    static update(obj : DataCacheUpdate, data : DataCacheUpdateOptions) {
        S.freeze(() => {
	        
	        
            if (data.Deletes !== undefined) _DataCacheUpdateEntities.update(obj.Deletes, data.Deletes);
            if (data.Timestamp !== undefined) obj.Timestamp(new TZDate(data.Timestamp));
            if (data.Updates !== undefined) _DataCacheUpdateEntities.update(obj.Updates, data.Updates);
        });
    }
}

// DataCacheUpdateEntitiesData is the class that DataCacheUpdateEntities serializes to/from
export interface DataCacheUpdateEntitiesData {
	
    BerthCapabilities : BerthCapabilityData[] | null;
    BerthCapabilityAssignments : BerthCapabilityAssignmentData[] | null;
    BerthClosures : BerthClosureData[] | null;
    BerthReservations : BerthReservationData[] | null;
    BerthReservationVersions : BerthReservationVersionData[] | null;
    Berths : BerthData[] | null;
    CargoActivities : CargoActivityData[] | null;
    Comments : CommentData[] | null;
    CoordinationCardRelevances : CoordinationCardRelevanceData[] | null;
    CoordinationCards : CoordinationCardData[] | null;
    CoordinationCardSelves : CoordinationCardSelfData[] | null;
    CoordinationCardVersions : CoordinationCardVersionData[] | null;
    Countries : CountryData[] | null;
    CruiseActivities : CruiseActivityData[] | null;
    Events : EventData[] | null;
    Issues : IssueData[] | null;
    ItineraryPoints : ItineraryPointData[] | null;
    ItineraryPointVersions : ItineraryPointVersionData[] | null;
    Locations : LocationData[] | null;
    LogEvents : LogEventData[] | null;
    Organizations : OrganizationData[] | null;
    OverrideServiceVessels : OverrideServiceVesselData[] | null;
    PierGroups : PierGroupData[] | null;
    PilotEntities : PilotsDataCacheUpdateEntitiesData | null;
    PortCallChanges : PortCallChangeData[] | null;
    PortCalls : PortCallData[] | null;
    PortCallVersions : PortCallVersionData[] | null;
    Ports : PortData[] | null;
    RecurringBatches : RecurringBatchData[] | null;
    ScheduleDateEvents : ScheduleDateEventData[] | null;
    ScheduleDates : ScheduleDateEntityData[] | null;
    Shares : ShareData[] | null;
    TaggedCommentUsers : TaggedCommentUserData[] | null;
    TopicCardAvailableAttachments : TopicCardAvailableAttachmentData[] | null;
    TopicCardChanges : TopicCardChangeData[] | null;
    TopicCardOptions : TopicCardOptionData[] | null;
    TopicCards : TopicCardData[] | null;
    TopicCardSelectedOptions : TopicCardSelectedOptionData[] | null;
    Users : PCUserData[] | null;
    VesselChanges : VesselChangeData[] | null;
    Vessels : VesselData[] | null;
    WartsilaEntities : WartsilaDataCacheUpdateEntitiesData | null;
	
}

// DataCacheUpdateEntitiesOptions is the class which may be passed to the DataCacheUpdateEntities constructor to define optional initial data values
export interface DataCacheUpdateEntitiesOptions {
	
    BerthCapabilities? : BerthCapabilityOptions[] | null;
    BerthCapabilityAssignments? : BerthCapabilityAssignmentOptions[] | null;
    BerthClosures? : BerthClosureOptions[] | null;
    BerthReservations? : BerthReservationOptions[] | null;
    BerthReservationVersions? : BerthReservationVersionOptions[] | null;
    Berths? : BerthOptions[] | null;
    CargoActivities? : CargoActivityOptions[] | null;
    Comments? : CommentOptions[] | null;
    CoordinationCardRelevances? : CoordinationCardRelevanceOptions[] | null;
    CoordinationCards? : CoordinationCardOptions[] | null;
    CoordinationCardSelves? : CoordinationCardSelfOptions[] | null;
    CoordinationCardVersions? : CoordinationCardVersionOptions[] | null;
    Countries? : CountryOptions[] | null;
    CruiseActivities? : CruiseActivityOptions[] | null;
    Events? : EventOptions[] | null;
    Issues? : IssueOptions[] | null;
    ItineraryPoints? : ItineraryPointOptions[] | null;
    ItineraryPointVersions? : ItineraryPointVersionOptions[] | null;
    Locations? : LocationOptions[] | null;
    LogEvents? : LogEventOptions[] | null;
    Organizations? : OrganizationOptions[] | null;
    OverrideServiceVessels? : OverrideServiceVesselOptions[] | null;
    PierGroups? : PierGroupOptions[] | null;
    PilotEntities? : PilotsDataCacheUpdateEntitiesOptions | null;
    PortCallChanges? : PortCallChangeOptions[] | null;
    PortCalls? : PortCallOptions[] | null;
    PortCallVersions? : PortCallVersionOptions[] | null;
    Ports? : PortOptions[] | null;
    RecurringBatches? : RecurringBatchOptions[] | null;
    ScheduleDateEvents? : ScheduleDateEventOptions[] | null;
    ScheduleDates? : ScheduleDateEntityOptions[] | null;
    Shares? : ShareOptions[] | null;
    TaggedCommentUsers? : TaggedCommentUserOptions[] | null;
    TopicCardAvailableAttachments? : TopicCardAvailableAttachmentOptions[] | null;
    TopicCardChanges? : TopicCardChangeOptions[] | null;
    TopicCardOptions? : TopicCardOptionOptions[] | null;
    TopicCards? : TopicCardOptions[] | null;
    TopicCardSelectedOptions? : TopicCardSelectedOptionOptions[] | null;
    Users? : PCUserOptions[] | null;
    VesselChanges? : VesselChangeOptions[] | null;
    Vessels? : VesselOptions[] | null;
    WartsilaEntities? : WartsilaDataCacheUpdateEntitiesOptions | null;
	
}

export class DataCacheUpdateEntities {
	
    public BerthCapabilities : SDataArray<BerthCapability>;
    public BerthCapabilityAssignments : SDataArray<BerthCapabilityAssignment>;
    public BerthClosures : SDataArray<BerthClosure>;
    public BerthReservations : SDataArray<BerthReservation>;
    public BerthReservationVersions : SDataArray<BerthReservationVersion>;
    public Berths : SDataArray<Berth>;
    public CargoActivities : SDataArray<CargoActivity>;
    public Comments : SDataArray<Comment>;
    public CoordinationCardRelevances : SDataArray<CoordinationCardRelevance>;
    public CoordinationCards : SDataArray<CoordinationCard>;
    public CoordinationCardSelves : SDataArray<CoordinationCardSelf>;
    public CoordinationCardVersions : SDataArray<CoordinationCardVersion>;
    public Countries : SDataArray<Country>;
    public CruiseActivities : SDataArray<CruiseActivity>;
    public Events : SDataArray<Event>;
    public Issues : SDataArray<Issue>;
    public ItineraryPoints : SDataArray<ItineraryPoint>;
    public ItineraryPointVersions : SDataArray<ItineraryPointVersion>;
    public Locations : SDataArray<Location>;
    public LogEvents : SDataArray<LogEvent>;
    public Organizations : SDataArray<Organization>;
    public OverrideServiceVessels : SDataArray<OverrideServiceVessel>;
    public PierGroups : SDataArray<PierGroup>;
    public PilotEntities : DataSignal<PilotsDataCacheUpdateEntities | null>;
    public PortCallChanges : SDataArray<PortCallChange>;
    public PortCalls : SDataArray<PortCall>;
    public PortCallVersions : SDataArray<PortCallVersion>;
    public Ports : SDataArray<Port>;
    public RecurringBatches : SDataArray<RecurringBatch>;
    public ScheduleDateEvents : SDataArray<ScheduleDateEvent>;
    public ScheduleDates : SDataArray<ScheduleDateEntity>;
    public Shares : SDataArray<Share>;
    public TaggedCommentUsers : SDataArray<TaggedCommentUser>;
    public TopicCardAvailableAttachments : SDataArray<TopicCardAvailableAttachment>;
    public TopicCardChanges : SDataArray<TopicCardChange>;
    public TopicCardOptions : SDataArray<TopicCardOption>;
    public TopicCards : SDataArray<TopicCard>;
    public TopicCardSelectedOptions : SDataArray<TopicCardSelectedOption>;
    public Users : SDataArray<PCUser>;
    public VesselChanges : SDataArray<VesselChange>;
    public Vessels : SDataArray<Vessel>;
    public WartsilaEntities : DataSignal<WartsilaDataCacheUpdateEntities | null>;
	

    constructor();
    constructor(data : DataCacheUpdateEntitiesOptions);
    constructor(data: DataCacheUpdateEntitiesOptions | null = null) {
	    
        this.BerthCapabilities = SArray<BerthCapability>([]);
        this.BerthCapabilityAssignments = SArray<BerthCapabilityAssignment>([]);
        this.BerthClosures = SArray<BerthClosure>([]);
        this.BerthReservations = SArray<BerthReservation>([]);
        this.BerthReservationVersions = SArray<BerthReservationVersion>([]);
        this.Berths = SArray<Berth>([]);
        this.CargoActivities = SArray<CargoActivity>([]);
        this.Comments = SArray<Comment>([]);
        this.CoordinationCardRelevances = SArray<CoordinationCardRelevance>([]);
        this.CoordinationCards = SArray<CoordinationCard>([]);
        this.CoordinationCardSelves = SArray<CoordinationCardSelf>([]);
        this.CoordinationCardVersions = SArray<CoordinationCardVersion>([]);
        this.Countries = SArray<Country>([]);
        this.CruiseActivities = SArray<CruiseActivity>([]);
        this.Events = SArray<Event>([]);
        this.Issues = SArray<Issue>([]);
        this.ItineraryPoints = SArray<ItineraryPoint>([]);
        this.ItineraryPointVersions = SArray<ItineraryPointVersion>([]);
        this.Locations = SArray<Location>([]);
        this.LogEvents = SArray<LogEvent>([]);
        this.Organizations = SArray<Organization>([]);
        this.OverrideServiceVessels = SArray<OverrideServiceVessel>([]);
        this.PierGroups = SArray<PierGroup>([]);
        this.PilotEntities = S.value<PilotsDataCacheUpdateEntities | null>(null);
        this.PortCallChanges = SArray<PortCallChange>([]);
        this.PortCalls = SArray<PortCall>([]);
        this.PortCallVersions = SArray<PortCallVersion>([]);
        this.Ports = SArray<Port>([]);
        this.RecurringBatches = SArray<RecurringBatch>([]);
        this.ScheduleDateEvents = SArray<ScheduleDateEvent>([]);
        this.ScheduleDates = SArray<ScheduleDateEntity>([]);
        this.Shares = SArray<Share>([]);
        this.TaggedCommentUsers = SArray<TaggedCommentUser>([]);
        this.TopicCardAvailableAttachments = SArray<TopicCardAvailableAttachment>([]);
        this.TopicCardChanges = SArray<TopicCardChange>([]);
        this.TopicCardOptions = SArray<TopicCardOption>([]);
        this.TopicCards = SArray<TopicCard>([]);
        this.TopicCardSelectedOptions = SArray<TopicCardSelectedOption>([]);
        this.Users = SArray<PCUser>([]);
        this.VesselChanges = SArray<VesselChange>([]);
        this.Vessels = SArray<Vessel>([]);
        this.WartsilaEntities = S.value<WartsilaDataCacheUpdateEntities | null>(null);
	    
    }

    static key(obj : DataCacheUpdateEntities) {
        return ;
    }
    
    static dataKey(obj : DataCacheUpdateEntitiesOptions) {
        return ;
    }

    static update(obj : DataCacheUpdateEntities, data : DataCacheUpdateEntitiesOptions) {
        S.freeze(() => {
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/DataCacheUpdate.ts